import {
  FETCH_SERVICE,
  FETCH_SERVICE_SUCCESS,
  FETCH_SERVICE_FAILURE,
  GENERATE_SERVICE_CODE,
  GENERATE_SERVICE_CODE_SUCCESS,
  GENERATE_SERVICE_CODE_FAILURE, 
  CREATE_SERVICE_REQUEST,
  CREATE_SERVICE_SUCCESS,
  CREATE_SERVICE_FAILURE,
  DELETE_SERVICE,
  DELETE_SERVICE_SUCCESS,
  DELETE_SERVICE_FAILURE,
  CHANGE_SERVICE_STATUS,
  CHANGE_SERVICE_STATUS_SUCCESS,
  CHANGE_SERVICE_STATUS_FAILURE
} from "./actionTypes";

// Fetch Service
export const fetchService = (unitId) => ({
  type: FETCH_SERVICE,
  payload: { unitId }
});

export const fetchServiceSuccess = (roles) => ({
  type: FETCH_SERVICE_SUCCESS,
  payload: roles,
});

export const fetchServiceFailure = (error) => ({
  type: FETCH_SERVICE_FAILURE,
  payload: error,
});

export const generateServiceCode = (unitId) => ({
  type: GENERATE_SERVICE_CODE,
  payload: { unitId }
});

export const generateServiceCodeSuccess = (roles) => ({
  type: GENERATE_SERVICE_CODE_SUCCESS,
  payload: roles,
});

export const generateServiceCodeFailure = (error) => ({
  type: GENERATE_SERVICE_CODE_FAILURE,
  payload: error,
});

// Create Service
export const createServiceRequest = (formData, isEdit) => ({
  type: CREATE_SERVICE_REQUEST,
  payload: { formData, isEdit },
});

export const createServiceSuccess = (response) => ({
  type: CREATE_SERVICE_SUCCESS,
  payload: response,
});

export const createServiceFailure = (error) => ({
  type: CREATE_SERVICE_FAILURE,
  payload: error,
});

export const changeServiceStatus = (payload) => ({
  type: CHANGE_SERVICE_STATUS,
  payload,
});

export const changeServiceStatusSuccess = (response) => ({
  type: CHANGE_SERVICE_STATUS_SUCCESS,
  payload: response,
});

export const changeServiceStatusFailure = (error) => ({
  type: CHANGE_SERVICE_STATUS_FAILURE,
  payload: error,
});

// Delete Service
export const deleteService = (formdata) => ({
  type: DELETE_SERVICE,
  payload: formdata,
});

export const deleteServiceSuccess = (response) => ({
  type: DELETE_SERVICE_SUCCESS,
  payload: response,
});

export const deleteServiceFailure = (error) => ({
  type: DELETE_SERVICE_FAILURE,
  payload: error,
});